<template>
  <div>
    <m-assembly-table ref='pageForm'
                      :formData='formData'
                      :columns='columns'
                      :data='tableData'
                      :loading='loading'
                      :currentPage='settings.currentPage'
                      :pageSize='settings.pageSize'
                      :total='settings.total'
                      :settings='settings'
                      @onSubmit='onSubmit'
                      @onPageSizeChange='onPageSizeChange'
                      @onCurrentPageChange='onPageChange'>
                        <div slot="tableHeader">
                            <div style="overflow:hidden;">
                                <div style="float:left;">
                                    <a id="anchor" style="margin:0 5px 0 10px;">
                                        <Button type="primary" :disabled="tableData.length === 0" :loading="exportLoading" @click="exportExcel">
                                            {{this.$t('commonTw.t1')}}
                                            <!-- 导出 -->
                                        </Button>
                                    </a>
                                    <set-table :columns="columns.columns" @setTableUpdate="setTableUpdate"></set-table>
                                </div>
                            </div>
                        </div>
    </m-assembly-table>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
// import ExcellentExport from 'excellentexport';
import { qmsApiSwitch } from '@/utils/tool';
export default {
    name: 'incomingInspection',
    components: { mAssemblyTable },
    data() {
        return {
            mdmCode: '',
            orgList: [],
            orgVal: '',
            condition: {},
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [30, 50, 80, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 30,
                total: null
            },
            formData: {
                row: 2,
                items: [
                    {
                        title: this.$t('typeTestProcessSearch.t21'), // 库存组织
                        placeholder: '', // 请选择库存组织
                        value: '',
                        field: 'ORG_CODE',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change: () => {
                                this.orgVal = this.formData.items[0].value;
                                console.log('this.orgVal:', this.orgVal);
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('typeTestProcessSearch.t22') // '组织不能为空'
                            }
                        }
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t45'), // 检验单号
                        value: '',
                        field: 'EXAMINED_NO',
                        type: 'text',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        }
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t31'), // 检验结果
                        placeholder: '',
                        value: '',
                        field: 'CHECKED_RESULT',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change: () => {
                                console.log('this.formData.items[2].value:', this.formData.items[2].value);
                            }
                        },
                        options: {
                            multiple: false,
                            values: [
                                {label: this.$t('typeTestProcessSearch.t65'), value: 'Accept'}, // 合格
                                {label: this.$t('typeTestProcessSearch.t66'), value: 'Reject'}] // Accept:合格/Reject：不合格
                        },
                        type: 'select',
                        validators: {
                            required: {
                                required: false,
                                message: ''
                            }
                        }
                    },
                    {
                        title: this.$t('incomingInspection.t1'), // '检验时间从',
                        isDouble: true,
                        value: moment(new Date()).subtract(6, 'd')._d,
                        field: 'CHECK_DATE_BEGIN',
                        type: 'datePicker',
                        style: 'width:100%',
                        layout: {
                            span: 8,
                            row: 2,
                            offset: 0
                        },
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('incomingInspection.t3'), // '请选择检验时间'
                            }
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd',
                            options: {
                                disabledDate(date) {}
                            }
                        },
                        change: (dateObj, time) => {
                        }
                    },
                    {
                        title: this.$t('incomingInspection.t2'), // '检验时间到',
                        hide: true,
                        value: new Date().getTime(),
                        field: 'CHECK_DATE_END',
                        type: 'datePicker',
                        style: 'width:100%',
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0
                        },
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('incomingInspection.t3'), // '请选择检验时间'
                            },
                            validator: (rule, value, callback, source, options) => {
                                let start = this.formData.items[3].value;
                                let end = this.formData.items[4].value;
                                if (new Date(start).getTime() > new Date(end).getTime()) {
                                    this.$Message.error(this.$t('incomingInspection.t4')); // 开始日期不能超过结束日期
                                    return false;
                                } else if ((new Date(end).getTime() - new Date(start).getTime()) / 86400000 > 30) {
                                    this.$Message.error(this.$t('incomingInspection.t5')); // 日期跨度不能超过31天
                                    // callback(['日期跨度不能超过30天']);
                                    return false;
                                } else {
                                    callback([]);
                                }
                            }
                         },
                         options: {
                             type: 'date',
                             format: 'yyyy-MM-dd'
                         }
                    }
                ],
                buttons: {
                    showSubmit: true,
                    showReset: true,
                    layout: {
                        span: 24,
                        push: 8
                    }
                }
            },
            columns: {
                showCheckbox: false,
                showButtons: false,
                columns: [
                    {
                        title: this.$t('typeTestProcessSearch.t45'), // '检验单号',
                        key: 'EXAMINED_NO',
                        sortable: true,
                        align: 'center',
                        minWidth: 140
                    },
                    {
                        title: this.$t('incomingInspection.t13'), // '检验日期',
                        key: 'CHECKED_DATE',
                        sortable: true,
                        align: 'center',
                        minWidth: 130
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t25'), // '送货单号',
                        key: 'BARCODE_NUMBER',
                        sortable: true,
                        align: 'left',
                        minWidth: 110
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t11'), // '物料编码',
                        key: 'ITEM_CODE',
                        sortable: true,
                        align: 'left',
                        minWidth: 120
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t12'), // '物料描述',
                        key: 'ITEM_DESC',
                        sortable: false,
                        align: 'left',
                        minWidth: 260,
                        render: (h, params) => {
                            return h('Tooltip', {
                                props: {
                                content: params.row.ITEM_DESC,
                                placement: 'top'
                                },
                                class: 'm-tooltip-overflow'
                            }, params.row.ITEM_DESC);
                        }
                    },
                    {
                        title: this.$t('incomingInspection.t8'), // '供货数',
                        key: 'RECEIVED_QUANTITY',
                        sortable: true,
                        align: 'right',
                        minWidth: 100
                    },
                    {
                        title: this.$t('incomingInspection.t7'), // '总批次',
                        key: 'EXAMINED_NO_TOTAL_BATCH',
                        sortable: true,
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('incomingInspection.t6'), // '任务批次',
                        key: 'BARCODE_NUMBER_TOTAL_BATCH',
                        sortable: true,
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('incomingInspection.t9'), // '不合格批次',
                        key: 'EXAMINED_NO_NG_BATCH',
                        sortable: true,
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('incomingInspection.t10'), // '不合格描述',
                        key: 'DETAIL_NG_INFO',
                        align: 'left',
                        minWidth: 80
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t31'), // '检验结果',
                        key: 'CHECKED_RESULT_TL',
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('incomingInspection.t11'), // '产地品牌',
                        key: 'BRAND',
                        align: 'center',
                        minWidth: 80
                    }
                ]
            },
            tableData: [],
            exportLoading: false
        };
    },
    methods: {
        /** 当前页改变时触发 */
        onPageChange(currentPage, pageSize, condition) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        /** 页容量改变时触发 */
        onPageSizeChange(currentPage, pageSize, condition) {
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onSubmit(page, pageSize, condition) {
            this.condition = condition;
            this.settings.currentPage = page;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        switchLanguage(lang) {
            switch (lang) {
                case 'zh-CN':
                    return 'ZHS';
                    break;
                case 'en-US':
                    return 'US';
                    break;
                case 'th':
                    return 'EN_TH';
                    break;
				default:
					return 'US';
            }
        },
        /** 搜索 */
        onSearch() {
            let params = {};
            this.formData.items.forEach(item => {
                if (item.field) {
                    params[item.field] = item.value;
                }
            });
            params.SUPPLIER_CODE = this.mdmCode;
            params.PAGE_INDEX = this.settings.currentPage;
            params.PAGE_SIZE = this.settings.pageSize;
            params.CHECK_DATE_BEGIN = params.CHECK_DATE_BEGIN ? moment(params.CHECK_DATE_BEGIN).format('YYYY-MM-DD') : '';
            params.CHECK_DATE_END = params.CHECK_DATE_END ? moment(params.CHECK_DATE_END).format('YYYY-MM-DD') : '';
            params.language = this.$i18n.locale;
            this.loading = true;
            this.exportLoading = true;
            this.tableData = [];
            axios.get(qmsApiSwitch(this, '/qms2gsc/RptIqcDetailExamined/GetDetailExaminedListForeign', params.ORG_CODE), {
                params: {
                    model: JSON.stringify(params)
                }
            }).then(res => {
                this.loading = false;
                this.exportLoading = false;
                let rep = JSON.parse(res.data.substring(1).substring(0, res.data.length - 3));
                if (rep.IsSucess) {
                    this.tableData = rep.MainResultData.DATA;
                    this.settings.total = rep.MainResultData.TOTAL;
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: rep.ErrorMessage
                    });
                }
            }).catch(() => {
                this.loading = false;
                this.exportLoading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        validAll() {
            let validate = false;
            this.$refs['pageForm'].$refs.queryForm.$refs.formData.validate(valid => {
                if (valid) {
                    validate = true;
                } else {
                    validate = false;
                }
            });
            return validate;
        },
        /** 导出Excel */
        exportExcel() {
            this.exportLoading = true;
            let params = {};
            this.formData.items.forEach(item => {
                if (item.field) {
                    params[item.field] = item.value;
                }
            });
            params.SUPPLIER_CODE = this.mdmCode;
            params.PAGE_INDEX = this.settings.currentPage;
            params.PAGE_SIZE = this.settings.pageSize;
            params.CHECK_DATE_BEGIN = params.CHECK_DATE_BEGIN ? moment(params.CHECK_DATE_BEGIN).format('YYYY-MM-DD') : '';
            params.CHECK_DATE_END = params.CHECK_DATE_END ? moment(params.CHECK_DATE_END).format('YYYY-MM-DD') : '';
            params.language = this.switchLanguage(this.$i18n.locale);
            params.isSaveLog = this.isPro() ? 'N' : 'Y'; // 生产环境传N，测试环境传Y
            var a = document.createElement('a');
            a.href = '/gscint/rptIqcDetailExamined/exportDetailExaminedList?model=' + encodeURI(JSON.stringify(params));
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(() => {
                this.exportLoading = false;
            }, 5000);
            // axios.get(`/gscint/rptIqcDetailExamined/exportDetailExaminedList`, {
            //     params: {
            //         model: params
            //     },
            //     responseType: 'blob'
            // })
            // .then((res) => {
            //     this.exportLoading = false;
            //     this.downloadFile(res.data, `美的来料判检查询.xlsx`);
            // })
            // .catch(() => {
            //     this.exportLoading = false;
            // });
        },
        setTableUpdate (columns) {
            this.columns.columns = columns;
        },
        /* 获取库存组织 */
        getOrgList () {
            this.getSRMInvLovListNew((data) => {
                let list = [];
                data.forEach((item) => {
                    list.push({
                        label: item.organizationName,
                        // value: item.erpOrgId
                        value: item.organizationCode
                    });
                });
                this.formData.items.map((item) => {
                    if (item.field === 'ORG_CODE') {
                        item.options.values = list;
                    }
                });
            });
        },
    },
    mounted() {
       console.log('this.$i18n.locale', this.$i18n.locale)
       this.mdmCode = JSON.parse(localStorage.getItem('supplierInfo')).mdmCode;
       this.getOrgList();
    }
};
</script>
